import { Action, ThunkDispatch } from '@reduxjs/toolkit';

import { EntityType } from '@frontend/common';
import { ReportClient } from '@frontend/report/api';
import { useResolver } from '@frontend/repository';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useReport:request': CustomEvent<string>;
    }
}

const REQUEST_REPORT_EVENT = 'useReport:request';
const STORAGE_KEY = 'REPORT_REQ';

export function reportRequest(reportId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_REPORT_EVENT, { detail: reportId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function ReportResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_REPORT_EVENT, EntityType.REPORT, (ids) => ReportClient.resolveReports(ids), props.dispatch);
    return <></>;
}